import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { ROUTE_HOME } from 'src/app/_common/constants';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})

export class SignInComponent implements OnInit {

  returnUrl: string;
  signInForm: FormGroup;
  userNameFormControl = new FormControl('', [Validators.required, Validators.email]);
  passwordFormControl = new FormControl('', [Validators.required]);
  isFromRedirect: boolean = false;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private appService: AppService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService) {

    //navigate if user is logged
    if (this.authService.authenticatedUser) {
      var url = (this.activatedRoute && this.activatedRoute.snapshot.queryParams['returnUrl']) || ROUTE_HOME;
      this.router.navigate([url]);
    }

    this.signInForm = this.formBuilder.group({
      userNameFormControl: this.userNameFormControl,
      passwordFormControl: this.passwordFormControl
    });

    this.isFromRedirect = this.router.getCurrentNavigation()?.extras.state?.isFromRedirect || false;
  }

  ngOnInit() {
    this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || ROUTE_HOME;

    if (!this.authService.authenticatedUser && !this.isFromRedirect) {      
      this.appService.callOpenLegalNoticeDialog();
    }
  }

  signIn() {
    this.authService.signIn(this.userNameFormControl.value, this.passwordFormControl.value)
      .pipe(map(authUser => {
        if(authUser.error.message){
          this.toastr.error(authUser.error.message);          
          return;
      }
        this.router.navigate([this.returnUrl]);
      })).subscribe();
  }
}
